import { useNavigate } from 'react-router-dom';

const ways = [
  {
    icon: 'ri-user-heart-line',
    title: 'Volunteer',
    description: 'Give your time and skills to make a direct difference. From mentoring to administrative support, every hour counts.',
    cta: 'Become a Volunteer',
    color: 'bg-teal-600',
    hoverColor: 'hover:bg-teal-700',
    lightBg: 'bg-teal-50',
    iconColor: 'text-teal-600',
  },
  {
    icon: 'ri-heart-add-line',
    title: 'Donate',
    description: 'Your financial contribution directly funds support services for individuals and families who need it most.',
    cta: 'Make a Donation',
    color: 'bg-orange-500',
    hoverColor: 'hover:bg-orange-600',
    lightBg: 'bg-orange-50',
    iconColor: 'text-orange-500',
  },
  {
    icon: 'ri-shake-hands-line',
    title: 'Partner With Us',
    description: 'Organizations, businesses, and faith communities — let\'s collaborate to expand our reach and deepen our impact.',
    cta: 'Explore Partnership',
    color: 'bg-teal-600',
    hoverColor: 'hover:bg-teal-700',
    lightBg: 'bg-teal-50',
    iconColor: 'text-teal-600',
  },
];

export default function GetInvolvedSection() {
  const navigate = useNavigate();
  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="get-involved" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="h-px w-10 bg-teal-500"></div>
            <span className="text-sm font-semibold text-teal-600 uppercase tracking-wider">Join the Mission</span>
            <div className="h-px w-10 bg-teal-500"></div>
          </div>
          <h3
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Get Involved
          </h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Building stronger communities takes all of us. Here's how you can be part of the change.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {ways.map((way, i) => (
            <div key={i} className="rounded-2xl border border-gray-100 overflow-hidden group hover:-translate-y-1 transition-all duration-300">
              <div className={`${way.lightBg} p-8`}>
                <div className="w-16 h-16 flex items-center justify-center bg-white rounded-2xl mb-6">
                  <i className={`${way.icon} text-3xl ${way.iconColor}`}></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
                  {way.title}
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  {way.description}
                </p>
              </div>
              <div className="p-6 bg-white">
                <button
                  onClick={() => way.title === 'Donate' ? navigate('/donate') : scrollToContact()}
                  className={`w-full py-3 ${way.color} ${way.hoverColor} text-white font-semibold rounded-xl transition-colors whitespace-nowrap cursor-pointer`}
                >
                  {way.cta}
                  <i className="ri-arrow-right-line ml-2"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
